import type { IconProps } from './Icon.types';

const PhoneIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  width = 14,
}) => {
  const height = Math.round(width * 0.9285);

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 13"
      width={width}
      height={height}
    >
      <path
        fill={fill}
        d="m9.168 9.24 1.12-1.12a1.095 1.095 0 0 1 1.17-.24l1.365.545a1.09 1.09 0 0 1 .68 1v2.5A1.086 1.086 0 0 1 12.363 13C2.798 12.405.868 4.305.503 1.205A1.085 1.085 0 0 1 1.588 0h2.415a1.08 1.08 0 0 1 1 .68l.545 1.365a1.08 1.08 0 0 1-.235 1.17l-1.12 1.12S4.838 8.7 9.168 9.24Z"
      />
    </svg>
  );
};

export default PhoneIcon;
